module.exports = __webpack_public_path__ + "static/media/YF05_5.cdb3e92c.jpg";